<template>
  <div>
    <b-row class="m-0">
      <b-col class="p-0">
        <fieldset class="border p-3">
          <legend class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">PERSONAL INFORMATION</legend>
          <b-row>
            <b-col>

                <b-form-group label="Employee ID Number:" description="This field is required">
                    <b-form-input v-model="params.form.id_number" type="text" required size="sm"></b-form-input>
                </b-form-group>
              <b-row>
                <b-col>
                  <b-form-group label="First Name:" description="This field is required">
                    <b-form-input v-model="params.form.first_name" type="text" required size="sm"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Middle Name:" description="This field is required">
                    <b-form-input v-model="params.form.middle_name" type="text" size="sm"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Last Name:" description="This field is required">
                    <b-form-input v-model="params.form.last_name" type="text" size="sm"></b-form-input>
                  </b-form-group>
                </b-col>
				  <b-col md="2">
					  <b-form-group label="Suffix:" description="e.g (Jr., Sr., Engr., etc...)">
						  <b-form-input v-model="params.form.suffix" type="text" size="sm"></b-form-input>
					  </b-form-group>
				  </b-col>
              </b-row>
              <b-row>
                  <b-col>
                      <b-form-group label="Nickname:" description="This field is required">
                          <b-form-input v-model="params.form.nickname" type="text" size="sm"></b-form-input>
                      </b-form-group>
                  </b-col>
                <b-col>
                  <b-form-group label="Date of Birth:" description="This field is required">
                    <b-form-input v-model="params.form.dob" type="date" size="sm"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Civil Status:" description="This field is required">
                    <select class="form-control form-control-sm" v-model="params.form.marital_status_id">
                      <option value>Please Select</option>
                      <option
                        v-for="marital_status in params.fields.marital_statuses"
                        :value="marital_status.id"
                      >{{marital_status.description}}</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Gender:" description="This field is required">
                    <select class="form-control form-control-sm" v-model="params.form.gender_id">
                      <option value>Please Select</option>
                      <option
                        v-for="gender in params.fields.genders"
                        :value="gender.id"
                      >{{gender.description}}</option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                      <b-col cols="2">

                          <b-form-group
                          label="Province:"
                          description="This field is required"
                          >
                              <select class="form-control form-control-sm" v-model="params.form.province_id" @change="fetchCities()">
                                  <option value="">Please Select</option>
                                  <option v-for="province in params.fields.provinces" :value="province.id">
                                      {{province.name}}
                                  </option>
                              </select>
                          </b-form-group>
                      </b-col>
                      <b-col cols="2">
                          <b-form-group
                          label="City:"
                          description="This field is required"
                          >
                              <select class="form-control form-control-sm" v-model="params.form.city_id">
                                  <option value="">Please Select</option>
                                  <option v-for="city in cities" :value="city.id">
                                      {{city.name}}
                                  </option>
                              </select>
                          </b-form-group>
                      </b-col>
                      <b-col>
                          <b-form-group
                          label="Barangay:"
                          description="This field is required"
                          >
                          <b-form-input
                              v-model="params.form.barangay"
                              type="text"
                              size="sm"
                          ></b-form-input>
                          </b-form-group>
                      </b-col>
                      <b-col>
                          <b-form-group
                          label="Street Address:"
                          description="This field is required"
                          >
                          <b-form-input
                              v-model="params.form.street_address"
                              type="text"
                              size="sm"
                          ></b-form-input>
                          </b-form-group>
                      </b-col>
                  </b-row>


                <b-row>
                    <b-col>
                        <b-form-group
                                label="SSS Number:"
                                description="This field is required"
                        >
                            <b-form-input
                                    v-model="params.form.sss_number"
                                    type="text"
                                    size="sm"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                                label="Philhealth Number:"
                                description="This field is required"
                        >
                            <b-form-input
                                    v-model="params.form.philhealth_number"
                                    type="text"
                                    size="sm"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                                label="PAGIBIG Number:"
                                description="This field is required"
                        >
                            <b-form-input
                                    v-model="params.form.pagibig_number"
                                    type="text"
                                    size="sm"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
          </b-row>
        </fieldset>
      </b-col>
    </b-row>

      <b-row class="m-0 mt-3">
          <b-col class="p-0">
              <fieldset class="border p-3 bg-light">
                  <legend class="w-auto bg-warning px-2 py-1 text-white rounded border h6">CONTACT DETAILS</legend>
                  <b-row>
                      <b-col>
                          <b-form-group label="Contact Number:" description="This field is required">
                              <b-form-input v-model="params.form.contact_number" type="text" size="sm"></b-form-input>
                          </b-form-group>
                      </b-col>
                      <b-col>
                          <b-form-group label="Work Email:" description="This field is required">
                              <b-form-input v-model="params.form.work_email" type="text" size="sm"></b-form-input>
                          </b-form-group>
                      </b-col>
                      <b-col>
                          <b-form-group label="Other Email:" description="This field is required">
                              <b-form-input v-model="params.form.other_email" type="text" size="sm"></b-form-input>
                          </b-form-group>
                      </b-col>
                  </b-row>
                  <fieldset class="border p-3 bg-white">
                      <legend class="w-auto bg-danger px-2 py-1 text-white rounded border h6">EMERGENCY CONTACTS <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="emergency_contact_modal=true" /></legend>
                      <table class="table table-bordered mt-2 mb-0 table-sm">
                          <thead class="thead-dark">
                          <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Relationship</th>
                              <th scope="col">Home Number</th>
                              <th scope="col">Mobile Number</th>
                              <th scope="col">Work Number</th>
                              <th scope="col" class="text-center">Action</th>
                          </tr>
                          </thead>
                          <tbody class="bg-white text-dark">
                          <tr v-for="(manpower_emergency_contact, index) in params.form.manpower_emergency_contacts">
                              <td>
                                  {{manpower_emergency_contact.name}}
                              </td>
                              <td>
                                  {{manpower_emergency_contact.relationship}}
                              </td>
                              <td>
                                  {{manpower_emergency_contact.home}}
                              </td>
                              <td>
                                  {{manpower_emergency_contact.mobile}}
                              </td>
                              <td>
                                  {{manpower_emergency_contact.work}}
                              </td>
                              <td class="text-center">
                                  <b-button size="sm" variant="danger" @click="deleteEmergencyContact(manpower_emergency_contact.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </fieldset>
              </fieldset>
          </b-col>
      </b-row>

    <b-row class="m-0 mt-3">
      <b-col class="p-0">
        <fieldset class="border p-3">
          <legend class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">OTHER DETAILS</legend>


            <b-row>
                <b-col>
                    <b-form-group
                            label="Blood Type:"
                            description="This field is required"
                    >
                        <select class="form-control form-control-sm" v-model="params.form.blood_type_id">
                            <option value="">Please Select</option>
                            <option v-for="blood_type in params.fields.blood_types" :value="blood_type.id">
                                {{blood_type.description}}
                            </option>
                        </select>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                            label="Shirt Size:"
                            description="This field is required"
                    >
                        <select class="form-control form-control-sm" v-model="params.form.shirt_size_id" >
                            <option value="">Please Select</option>
                            <option v-for="shirt_size in params.fields.shirt_sizes" :value="shirt_size.id">
                                {{shirt_size.description}}
                            </option>
                        </select>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr>

            <b-row>
                <b-col>
                    <b-form-group
                            label="Salary Type:"
                            description="This field is required"
                    >
                        <select class="form-control form-control-sm" v-model="params.form.salary_type_id">
                            <option :value="null">Please Select</option>
                            <option v-for="salary_type in params.fields.salary_types" :value="salary_type.id">
                                {{salary_type.description}}
                            </option>
                        </select>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                            label="Shift / Payroll Group:"
                            description="Sets the office schedule and which payroll group the employee is paid with"
                    >
                        <select class="form-control form-control-sm" v-model="params.form.shift_type_id" >
                            <option :value="null">Please Select</option>
                            <optgroup v-for="group in shiftGroups" :key="group.name" :label="group.name">
                                <option v-for="shift_type in group.shifts" :key="shift_type.id" :value="shift_type.id">
                                    {{shift_type.description}} ({{ scheduleText(shift_type) }})<template v-if="!shift_type.is_active"> - inactive</template>
                                </option>
                            </optgroup>
                        </select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group
                            label="SSS Contribution:"
                            description="This field is required"
                    >
                        <b-form-input
                                v-model="params.form.sss"
                                type="number"
                                step="any"
                                size="sm"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                            label="HDMF Contribution:"
                            description="This field is required"
                    >
                        <b-form-input
                                v-model="params.form.hdmf"
                                type="number"
                                step="any"
                                size="sm"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                            label="PHILHEALTH Contribution:"
                            description="This field is required"
                    >
                        <b-form-input
                                v-model="params.form.phic"
                                type="number"
                                step="any"
                                size="sm"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </fieldset>
      </b-col>
    </b-row>
      <b-modal v-model="emergency_contact_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <emergency-contact-form @save="save"/>
      </b-modal>
  </div>
</template>
<script>
import { assets_path } from "@/config";
import SwalMixin from "@/views/mixins/Swal.js";
import Loader from "@/views/helpers/LoaderComponent.vue";
import EmergencyContactForm from './EmergencyContactForm.vue';
export default {
  mixins: [SwalMixin],
  components: {
    Loader,
      EmergencyContactForm
  },
  props: {
    params: {
      type: Object,
      default: {},
      required: true,
    },
  },
  data() {
    return {
      item: {
        image: null,
        imageUrl: null,
        imageName: "",
      },
      is_saving: false,
      upload_modal: false,
      percentage: 0,
      loading_color: "facebook",
      max_upload_percentage: 100,
      hide_submit_btn: false,
      assets_path: {},
        cities:[],
        emergency_contact_modal:false,
    };
  },
    computed: {
        // Active shifts grouped under their payroll group for the dropdown.
        shiftGroups() {
            const groups = [];
            (this.params.fields.shift_types || []).forEach(s => {
                const name = s.payroll_group ? s.payroll_group.name : 'No payroll group';
                let g = groups.find(x => x.name === name);
                if (!g) { g = { name: name, shifts: [] }; groups.push(g); }
                g.shifts.push(s);
            });
            return groups;
        },
    },
    watch: {
        params:{
            immediate: true,
            deep:true,
            handler(){
                this.assignCities();
            }
        }
    },
  created() {
    this.assets_path = assets_path;
  },
  methods: {
      scheduleText(s){
          const hm = v => { if (!v) return '--'; const p = v.split(':'); let h = parseInt(p[0], 10); const ampm = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + ':' + p[1] + ampm; };
          return hm(s.am_time_in) + '-' + hm(s.pm_time_out) + ', ' + Number(s.required_duty_hours || 0) + 'h duty';
      },
      fetchCities(){
          this.params.form.city_id = "";
          this.axios.get('maintenance/provinces/fetch-cities',{params:{id:this.params.form.province_id}}).then(response => {
              this.cities = response.data;
          }).catch(error => console.log(error));
      },
      assignCities(){
          this.axios.get('maintenance/provinces/fetch-cities',{params:{id:this.params.form.province_id}}).then(response => {
              this.cities = response.data;
          }).catch(error => console.log(error));
      },
      save(){
          this.$emit('save');
          this.emergency_contact_modal=false;
      },
      deleteEmergencyContact(id){
          this.swalConfirmDelete((data)=>{
              if (data.value) {
                  this.is_saving=true;
                  this.axios.delete('maintenance/manpowers/emergency-contacts/delete',{ data: {id:id} }).then(response => {
                      this.swalTransactionCompleted();
                      this.is_saving=false;
                      this.$emit('save');
                  }).catch(error => {
                      this.swal_transaction_error_data.text = error.response.data;
                      this.swalRequestError();
                      this.is_saving=false;
                  });
              }
          });
      }
  },
};
</script>
